import { styled } from '@atom-web/core'
import Calendar from '@atom-web/icons-24/jsx/Calendar'
import Flag from '@atom-web/icons-24/jsx/Flag'
import { Popover } from '@atom-web/macros'
import { Button, Column, Input, Row, Text } from '@atom-web/micros'

import plural from '../../../../utils/plural'

const DurationOfStay = ({
	durations = [],
	duration,
	onclick,
	increement,
	decreement,
	open,
	dropDownOnchange,
}) => {
	const Span = styled('span', {
		fontSize: '$1',
		fontWeight: '$bold',
		color: '$grey03',
		marginRight: '$2',
		alignItems: 'center',
		display: 'flex',
	})
	return (
		<>
			<Calendar />
			<Column css={{ width: '90%' }}>
				<Popover.Root open={open} onOpenChange={val => dropDownOnchange(val)}>
					<Popover.Trigger asChild>
						<Input
							type={'text'}
							placeholder="Duration of stay"
							css={{
								boxShadow: 'none',
								color: '#2c2f42',
								fontSize: '16px',
								fontFamily: 'Source Sans Pro',
								paddingLeft: '$1',
								userSelect: 'none',
								'&:focus': {
									boxShadow: 'none',
								},
								'&::placeholder': {
									color: '#2c2f42',
									fontSize: '16px',
									fontFamily: 'Source Sans Pro',
									paddingLeft: '$1',
									userSelect: 'none',
								},
							}}
							value={
								duration +
								' ' +
								plural({
									count: duration,
									keyword: 'night',
								})
							}
						/>
					</Popover.Trigger>
					<Popover.Content
						css={{
							backgroundColor: '$white',
							marginTop: '30px',
							height: '250px',
							width: '250px',
							padding: 0,
						}}
					>
						<Column css={{ height: '80%' }}>
							{durations.slice(0, 4).map((item, index) => {
								return (
									<Row
										justify={'between'}
										key={index}
										align={'center'}
										css={{
											height: '25%',
											boxShadow: 'rgb(229 229 229) 0px 1px 0px 0px',
											'&:hover': {
												backgroundColor: '$white',
												boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 15px',
												borderTopLeftRadius: index == 0 ? '$3' : 0,
												borderTopRightRadius: index == 0 ? '$3' : 0,
											},
										}}
										onClick={() => onclick(index + 1)}
									>
										<Text
											css={{
												fontSize: '$4',
												color: '$black',
												lineHeight: '21px',
												fontWeight: '$normal',
												marginLeft: '$4',
												userSelect: 'none',
											}}
										>
											{index + 1} {item.val}
										</Text>
										{index == 3 ? (
											<Span>
												<Flag
													fill="#00c684"
													fontSize={'16px'}
													style={{ marginRight: '4px', marginBottom: '2px' }}
												/>
												Ideal for Maldives
											</Span>
										) : null}
									</Row>
								)
							})}
						</Column>
						<Row
							align={'center'}
							justify="between"
							css={{
								height: '20%',
								padding: '$3',
								'&:hover': {
									backgroundColor: '$white',
									boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 15px',
									borderBottomLeftRadius: '$3',
									borderBottomRightRadius: '$3',
								},
							}}
						>
							<Button
								onClick={decreement}
								css={{
									borderRadius: '$round',
									backgroundColor: 'transparent',
									height: '32px',
									width: '32px',
									boxShadow: 'none',
									border:
										durations.length === 4
											? '$custom18 solid 1px'
											: '$custom14 solid 1px',
									color: '$black',
								}}
								disabled={durations.length === 4}
							>
								-
							</Button>
							<Text
								css={{
									userSelect: 'none',
								}}
							>
								{durations.length} nights
							</Text>

							<Button
								onClick={increement}
								css={{
									borderRadius: '$round',
									backgroundColor: 'transparent',
									height: '32px',
									width: '32px',
									boxShadow: 'none',
									color: '$black',
									border:
										durations.length === 10
											? '$custom18 solid 1px'
											: '$custom14 solid 1px',
								}}
								disabled={durations.length === 10}
							>
								+
							</Button>
						</Row>
					</Popover.Content>
				</Popover.Root>
			</Column>
		</>
	)
}
export default DurationOfStay
